import { gql } from "@apollo/client";

export const ValidateIoTConnectionInput = gql`
    query ValidateIoTConnectionInput($input: ValidateIoTConnectionInput!) {
        validateIoTConnectionInput(input: $input) {
            isValid
            error {
                errorCode
                message
            }
        }
    }
`;
